<button
  *ngrxLet="isDisabled$ as disabled"
  mat-raised-button
  class="image !h-full"
  matTooltip="TWAIN integration requires patient date of birth"
  [matTooltipDisabled]="!disabled"
  [disabled]="disabled"
  (click)="scan()"
>
  TWAIN Scan
</button>
